import React from 'react';
import styled from 'styled-components';
import { variables } from '../../../utils';

const TrackerArea = styled.div.attrs({
  className: 'flex-none flex ml2-l'
})`
  @media (min-width: ${variables.large}px) {
    min-width: 270px;
  }
`;

const TrackerInputShell: React.FC<{ trackerName: string; 'data-testid'?: string }> = ({
  children,
  trackerName,
  ...rest
}) => (
  <div className="flex-l items-center justify-between" {...rest}>
    <p className="f6 mt1 mb2">{trackerName}</p>
    <TrackerArea>{children}</TrackerArea>
  </div>
);

export default TrackerInputShell;
